module.exports = __webpack_public_path__ + "static/assets/fb74f776b304831d5ae550522c061c01.png";